// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import App from './App'
import router from './router'
import jQuery from 'jquery'
import VueObserveVisibility from 'vue-observe-visibility'
import vueSmoothScroll from 'vue-smooth-scroll'
import 'animate.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)

Vue.prototype.$axios = axios
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuex)
Vue.use(VueObserveVisibility)
Vue.use(vueSmoothScroll)
Vue.config.productionTip = false

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js